/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Booking_Sync_Not_SyncedInputs */

const en_booking_sync_not_synced = /** @type {(inputs: Booking_Sync_Not_SyncedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Not sent`)
};

/**
* | output |
* | --- |
* | "Not sent" |
*
* @param {Booking_Sync_Not_SyncedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const booking_sync_not_synced = /** @type {((inputs?: Booking_Sync_Not_SyncedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Booking_Sync_Not_SyncedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_booking_sync_not_synced(inputs)
});